export const FRAMERATE_PARAMETERS_TOKEN = "{framerateParameters}";
